import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Speed: "),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.speed_settings, (item) => {
      return _createElementVNode("label", {
        key: item.name
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "speed",
          value: item.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.speed) = $event))
        }, null, 8 /* PROPS */, _hoisted_1), [
          [_vModelRadio, $setup.speed]
        ]),
        _createTextVNode(" " + _toDisplayString(item.name), 1 /* TEXT */)
      ])
    }), 64 /* STABLE_FRAGMENT */))
  ]))
}